"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIsSubscribedCookie = exports.getIsSubscribedCookie = void 0;

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _makeCookieName = require("./makeCookieName");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cookieName = (0, _makeCookieName.makeCookieName)("isSubscribed");

var getIsSubscribedCookie = function getIsSubscribedCookie() {
  var cookies = new _universalCookie["default"]();
  return cookies.get(cookieName);
};

exports.getIsSubscribedCookie = getIsSubscribedCookie;

var setIsSubscribedCookie = function setIsSubscribedCookie(value) {
  var cookies = new _universalCookie["default"]();
  cookies.set(cookieName, value);
  return cookies.get(cookieName);
};

exports.setIsSubscribedCookie = setIsSubscribedCookie;